import styled from 'styled-components';

export const IngredientsSection = styled.div`
  background-color: ${props => props.theme.colors.background.base};
  width: 100%;
  padding: ${props => props.theme.spacing(8, 2)};
  text-align: center;
  @media ${props => props.theme.tablet} {
    padding: ${props => props.theme.spacing(12, 6)};
  }
  @media ${props => props.theme.laptop} {
    padding: ${props => props.theme.spacing(12, 20)};
  }
`;

export const IngredientsHeadline = styled.h2`
  padding-bottom: ${props => props.theme.spacing(2)};
`;

export const IngredientsSubheadline = styled.p`
  ${props => props.theme.typography.subheading2};
  padding-bottom: ${props => props.theme.spacing(8)};
  @media ${props => props.theme.laptop} {
    ${props => props.theme.typography.body};
    padding-bottom: ${props => props.theme.spacing(10)};
  }
`;

export const StyledIngredientsList = styled.div`
  display: grid;
  grid-gap: ${props => props.theme.spacing(12)};
`;

export const CardContainer = styled.div`
  height: 100%;
  width: 100%;
`;

export const IngredientBody = styled.p`
  ${props => props.theme.typography.body};
`;

export const SelectorContainer = styled.div`
  max-width: 352px;
  width: 100%;
  place-self: center;
`;

export const FullIngredientsButton = styled.button`
  ${props => props.theme.typography.body};
  margin-bottom: ${props => props.theme.spacing(8)};
  color: ${props => props.theme.colors.text.primary};
  background-color: transparent;
  border: 0;
`;
